module.exports = __webpack_public_path__ + "static/media/coral-reef.856cc961.jpg";